const currentUserAttributes = ` User_Id
  First_Name
  Last_Name
  Email
  Phone
  Account_Id
  Organization_Id
  Organization{
    Name
  }
  Cognito_Id
  Last_Login
  Teaching_Grade
  Teaching_Subject
  Award_Level
  Saved_Grants {Grant_Id}
  Not_Interested {Grant_Id}
  State
  Last_Feed_View
  Permissions {
    UserPermission_Id
    Organization {
      Organization_Id
      Name
    }
    Permission {
      Permission_Id
      Title
    }
  }
  AccountGroup {
    AccountGroup_Id
  }
  Account{
    District_Contacts{
      District_Contact_Id
      Name
      Email
      Phone
      Address_Line_1
      Address_Line_2
      City
      State
      Zip
      District_Contact_Type_Id
    }
  }`;

const user = {
  loadUser: async function(cognitoId) {
    var view = this;
    var res = await view.$store.getters.fetcher({
      query:
        `{
        userByCognito(cognitoId: "` +
        cognitoId +
        `") 
        {` +
        currentUserAttributes +
        `}
      }`
    });
    var user = res.data.userByCognito;
    if (user.Saved_Grants == undefined) {
      user.Saved_Grants = [];
    }
    if (user.Not_Interested == undefined) {
      user.Not_Interested = [];
    }
    view.$store.commit("updateUser", user);
  },

  updateUser: async function(userToUpdate) {
    var view = this;
    const query =
      `
      mutation($userId: Int!, $firstName: String!, $lastName: String!, $email: String!, $phone: String!, $teachingGrade: Int!, $teachingSubject: Int!, $awardLevel: Int!) {
        UpdateUserPreferences(userId: $userId, firstName: $firstName, lastName: $lastName, email: $email, phone: $phone, teachingGrade: $teachingGrade, teachingSubject: $teachingSubject, awardLevel: $awardLevel) 
        {` +
      currentUserAttributes +
      `}
      }`;
    const variables = {
      userId: parseInt(view.$store.getters.user.User_Id),
      firstName: userToUpdate.firstName,
      lastName: userToUpdate.lastName,
      email: userToUpdate.email.toLowerCase(),
      phone: userToUpdate.phone,
      teachingGrade: view.$createGrantFlag(userToUpdate.teachingGrade),
      teachingSubject: view.$createGrantFlag(userToUpdate.teachingSubject),
      awardLevel: view.$createGrantFlag(userToUpdate.awardLevel)
    };
    return await view.$store.getters
      .fetcher({ query, variables })
      .then(r => r.data.UpdateUserPreferences);
  },

  updateLastLogin: async function() {
    var view = this;
    await view.$store.getters
      .fetcher({
        query: `mutation($userId: Int!, $lastLogin: Date!){
        UpdateUserLastLogin(userId: $userId, lastLogin: $lastLogin){
          Last_Login
        }
      }`,
        variables: {
          userId: parseInt(view.$store.getters.user.User_Id),
          lastLogin: Date()
        }
      })
      .then(lastLoginUpdate => {
        var user = Object.assign({}, view.$store.getters.user);
        user.Last_Login = lastLoginUpdate.data.UpdateUserLastLogin.Last_Login;
        view.$store.commit("updateUser", user);
        return true;
      });
  },

  updateLastFeedView: async function() {
    var view = this;
    await view.$store.getters
      .fetcher({
        query: `mutation($userId: Int!, $lastFeedView: Date!){
        UpdateUserLastFeedView(userId: $userId, lastFeedView: $lastFeedView){
          Last_Feed_View
        }
      }`,
        variables: {
          userId: parseInt(view.$store.getters.user.User_Id),
          lastFeedView: Date()
        }
      })
      .then(lastFeedViewUpdate => {
        var user = Object.assign({}, view.$store.getters.user);
        user.Last_Feed_View =
          lastFeedViewUpdate.data.UpdateUserLastFeedView.Last_Feed_View;
        view.$store.commit("updateUser", user);
        return true;
      });
  },

  updateUserOrganization: async function(userId, organizationId) {
    var view = this;
    await view.$store.getters
      .fetcher({
        query: `mutation($userId: Int!, $organizationId: Int!){
        UpdateUserOrganization(userId: $userId, organizationId: $organizationId){
          User_Id
        }
      }`,
        variables: {
          userId: parseInt(userId),
          organizationId: parseInt(organizationId)
        }
      })
      .then(() => {
        return organizationId;
      });
  },

  getAccountManagementUserCount: async function(
    firstName,
    lastName,
    accountGroup
  ) {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        userQueryCount(firstName: "` +
          firstName +
          '", lastName: "' +
          lastName +
          '", accountGroup: ' +
          accountGroup +
          `)}`
      })
      .then(r => r.data.userQueryCount);
  },

  getAccountManagementUsers: async function(
    firstName,
    lastName,
    accountGroup,
    offset,
    limit
  ) {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        userQuery(firstName: "` +
          firstName +
          '", lastName: "' +
          lastName +
          '", accountGroup: ' +
          accountGroup +
          ", offset: " +
          offset +
          ", limit: " +
          limit +
          `) 
        {
          User_Id
          First_Name
          Last_Name
          Email
          Phone
          Account_Id
          Organization_Id
          Organization{
            Organization_Id
            Name
          }
          Cognito_Id
          Permissions {
            UserPermission_Id
            Organization {
              Organization_Id
              Name
            }
            Permission {
              Permission_Id
              Title
            }
          }
        }
      }`
      })
      .then(r => r.data.userQuery);
  }
};

export { user };
